import script from "./AboutScreen.vue?vue&type=script&setup=true&lang=js"
export * from "./AboutScreen.vue?vue&type=script&setup=true&lang=js"

import "./AboutScreen.vue?vue&type=style&index=0&id=4d741b9a&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4d741b9a"]])

export default __exports__